export const Data = [
    {
        q: "What does Ayurveda focus on?",
        a: "Maintaining balance in body systems",
        b: "A medical procedure",
        c: "Western medicine",
        d: "Surgery techniques",
        ans: "Maintaining balance in body systems"
    },
    {
        q: "What is the ancient text of Ayurveda called?",
        a: "Bhagavad Gita",
        b: "Charaka Samhita",
        c: "Mahabharata",
        d: "Vedas",
        ans: "Charaka Samhita"
    },
    {
        q: "What is the key concept in Ayurveda?",
        a: "Doshas (Vata, Pitta, Kapha)",
        b: "Chakras",
        c: "Qi",
        d: "Yoga postures",
        ans: "Doshas (Vata, Pitta, Kapha)"
    },
    {
        q: "Which herb is widely used in Ayurveda for digestion?",
        a: "Neem",
        b: "Ashwagandha",
        c: "Triphala",
        d: "Tulsi",
        ans: "Triphala"
    },
    {
        q: "What is the Sanskrit word for health in Ayurveda?",
        a: "Arogya",
        b: "Swasthya",
        c: "Dhanvantari",
        d: "Prakriti",
        ans: "Swasthya"
    },
    {
        q: "Which plant is commonly used in Ayurveda for immunity?",
        a: "Ashwagandha",
        b: "Tulsi",
        c: "Brahmi",
        d: "Neem",
        ans: "Tulsi"
    },
    {
        q: "What are the three doshas in Ayurveda?",
        a: "Vata, Pitta, Kapha",
        b: "Prana, Tejas, Ojas",
        c: "Sattva, Rajas, Tamas",
        d: "Yoga, Pranayama, Meditation",
        ans: "Vata, Pitta, Kapha"
    },
    {
        q: "Which Ayurveda treatment involves detoxification?",
        a: "Panchakarma",
        b: "Shirodhara",
        c: "Abhyanga",
        d: "Nasya",
        ans: "Panchakarma"
    },
    {
        q: "Who is known as the Father of Ayurveda?",
        a: "Charaka",
        b: "Sushruta",
        c: "Dhanvantari",
        d: "Patanjali",
        ans: "Charaka"
    },
    {
        q: "What is Ashwagandha used for in Ayurveda?",
        a: "Improving mental health",
        b: "Weight loss",
        c: "Boosting immunity",
        d: "Skin care",
        ans: "Improving mental health"
    },
    {
        q: "Which dosha represents the element of fire in Ayurveda?",
        a: "Vata",
        b: "Pitta",
        c: "Kapha",
        d: "Agni",
        ans: "Pitta"
    },
    {
        q: "Which Ayurvedic herb is known for enhancing memory and concentration?",
        a: "Neem",
        b: "Brahmi",
        c: "Shatavari",
        d: "Amalaki",
        ans: "Brahmi"
    },
    {
        q: "What is the term for the life force energy in Ayurveda?",
        a: "Qi",
        b: "Prana",
        c: "Dosha",
        d: "Agni",
        ans: "Prana"
    },
    {
        q: "Which oil is commonly used in Ayurvedic massage therapy?",
        a: "Olive oil",
        b: "Sesame oil",
        c: "Almond oil",
        d: "Coconut oil",
        ans: "Sesame oil"
    },
    {
        q: "Which Ayurvedic treatment focuses on mental relaxation?",
        a: "Shirodhara",
        b: "Abhyanga",
        c: "Nasya",
        d: "Panchakarma",
        ans: "Shirodhara"
    }
]
